import { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Dropdown = ({ 
  trigger, 
  items = [], 
  isOpen, 
  onToggle, 
  position = 'bottom-left',
  className = '' 
}) => {
  const dropdownRef = useRef(null);
  const triggerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          triggerRef.current && !triggerRef.current.contains(event.target)) {
        onToggle(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onToggle]);

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick(item);
    }
    onToggle(false);
  };

  return (
    <div className={`dropdown-container ${className}`}>
      <div 
        ref={triggerRef}
        className="dropdown-trigger"
        onClick={() => onToggle(!isOpen)}
      >
        {trigger}
      </div>
      
      {isOpen && (
        <div 
          ref={dropdownRef}
          className={`dropdown-menu dropdown-${position}`}
          style={{
            opacity: 1,
            transform: 'none',
            transition: 'opacity 356ms cubic-bezier(0.4, 0, 0.2, 1), transform 237ms cubic-bezier(0.4, 0, 0.2, 1)'
          }}
        >
          <ul className="dropdown-list" role="menu">
            {items.map((item, index) => {
              const content = (
                <span className="dropdown-item-content text-sm">
                  {item.label}
                  {item.badge && (
                    <div className={`dropdown-badge dropdown-badge-${item.badge.type}`}>
                      <span className="dropdown-badge-label">
                        {item.badge.text}
                      </span>
                    </div>
                  )}
                </span>
              );

              return (
                <li 
                  key={item.id || index}
                  className="dropdown-item"
                  role="menuitem"
                  tabIndex={index === 0 ? 0 : -1}
                  onClick={() => handleItemClick(item)}
                >
                  {item.href ? (
                    <Link to={item.href} className="dropdown-link">
                      {content}
                    </Link>
                  ) : (
                    content
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export { Dropdown };